import { render, staticRenderFns } from "./PxCriterioUsuario.vue?vue&type=template&id=eb2de6a2&"
import script from "./PxCriterioUsuario.vue?vue&type=script&lang=js&"
export * from "./PxCriterioUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports